export const monacoThemes = {
    vs: {
        base: 'vs',
        inherit: true,
        rules: [
            { token: 'keyword', foreground: '0000FF', fontStyle: 'bold' },
            { token: 'constant.numeric', foreground: '000000' },
            { token: 'string', foreground: 'A31515' },
            { token: 'comment', foreground: '008000', fontStyle: 'italic' },
            { token: 'support.function', foreground: '000080' },
            { token: 'constant.language', foreground: '0000FF' },
            // HTML
            { token: 'tag', foreground: '800000' },
            { token: 'tag.id', foreground: '800000' },
            { token: 'tag.class', foreground: '800000' },
            { token: 'attribute.name', foreground: 'FF0000' },
            { token: 'attribute.value', foreground: '0000FF' },
            { token: 'delimiter.html', foreground: '000000' },
            // CSS
            { token: 'tag.css', foreground: '800000' },
            { token: 'attribute.name.css', foreground: 'FF0000' },
            { token: 'attribute.value.css', foreground: '0000FF' },
            { token: 'keyword.css', foreground: '0000FF' },
            { token: 'delimiter.css', foreground: '000000' },
            { token: 'number.css', foreground: '000000' },
            { token: 'string.css', foreground: 'A31515' },
            { token: 'unit.css', foreground: '000000' }
        ],
        colors: {
            'editor.background': '#FFFFFF',
            'editor.foreground': '#000000',
            'editor.lineHighlightBackground': '#00000012',
            'editorCursor.foreground': '#000000',
            'editor.selectionBackground': '#ADD6FF'
        }
    },
    vsDark: {
        base: 'vs-dark',
        inherit: true,
        rules: [
            { token: 'keyword', foreground: '569CD6', fontStyle: 'bold' },
            { token: 'constant.numeric', foreground: 'B5CEA8' },
            { token: 'string', foreground: 'CE9178' },
            { token: 'comment', foreground: '6A9955', fontStyle: 'italic' },
            { token: 'support.function', foreground: 'DCDCAA' },
            { token: 'constant.language', foreground: '569CD6' },
            // HTML
            { token: 'tag', foreground: '569CD6' },
            { token: 'tag.id', foreground: '569CD6' },
            { token: 'tag.class', foreground: '569CD6' },
            { token: 'attribute.name', foreground: '9CDCFE' },
            { token: 'attribute.value', foreground: 'CE9178' },
            { token: 'delimiter.html', foreground: 'D4D4D4' },
            // CSS
            { token: 'tag.css', foreground: '569CD6' },
            { token: 'attribute.name.css', foreground: '9CDCFE' },
            { token: 'attribute.value.css', foreground: 'CE9178' },
            { token: 'keyword.css', foreground: '569CD6' },
            { token: 'delimiter.css', foreground: 'D4D4D4' },
            { token: 'number.css', foreground: 'B5CEA8' },
            { token: 'string.css', foreground: 'CE9178' },
            { token: 'unit.css', foreground: 'B5CEA8' }
        ],
        colors: {
            'editor.background': '#1E1E1E',
            'editor.foreground': '#D4D4D4',
            'editor.lineHighlightBackground': '#FFFFFF12',
            'editorCursor.foreground': '#FFFFFF',
            'editor.selectionBackground': '#264F78'
        }
    },
    chrome: {
        base: 'vs',
        inherit: true,
        rules: [
            { token: 'keyword', foreground: '000080', fontStyle: 'bold' },
            { token: 'constant.numeric', foreground: '0000CD' },
            { token: 'string', foreground: '036A07' },
            { token: 'comment', foreground: '008E00', fontStyle: 'italic' },
            { token: 'support.function', foreground: '0000FF' },
            { token: 'constant.language', foreground: '0000FF' },
            // HTML
            { token: 'tag', foreground: '000080' },
            { token: 'tag.id', foreground: '000080' },
            { token: 'tag.class', foreground: '000080' },
            { token: 'attribute.name', foreground: '0000FF' },
            { token: 'attribute.value', foreground: '036A07' },
            { token: 'delimiter.html', foreground: '000000' },
            // CSS
            { token: 'tag.css', foreground: '000080' },
            { token: 'attribute.name.css', foreground: '0000FF' },
            { token: 'attribute.value.css', foreground: '036A07' },
            { token: 'keyword.css', foreground: '000080' },
            { token: 'delimiter.css', foreground: '000000' },
            { token: 'number.css', foreground: '0000CD' },
            { token: 'string.css', foreground: '036A07' },
            { token: 'unit.css', foreground: '0000CD' }
        ],
        colors: {
            'editor.background': '#FFFFFF',
            'editor.foreground': '#000000',
            'editor.lineHighlightBackground': '#00000012',
            'editorCursor.foreground': '#000000',
            'editor.selectionBackground': '#B5D5FF'
        }
    },
    monokai: {
        base: 'vs-dark',
        inherit: true,
        rules: [
            { token: 'keyword', foreground: 'F92672' },
            { token: 'constant.numeric', foreground: 'AE81FF' },
            { token: 'string', foreground: 'E6DB74' },
            { token: 'comment', foreground: '75715E', fontStyle: 'italic' },
            { token: 'support.function', foreground: '66D9EF' },
            { token: 'constant.language', foreground: 'AE81FF' },
            // HTML
            { token: 'tag', foreground: 'F92672' },
            { token: 'tag.id', foreground: 'F92672' },
            { token: 'tag.class', foreground: 'F92672' },
            { token: 'attribute.name', foreground: 'A6E22E' },
            { token: 'attribute.value', foreground: 'E6DB74' },
            { token: 'delimiter.html', foreground: 'F8F8F2' },
            // CSS
            { token: 'tag.css', foreground: 'F92672' },
            { token: 'attribute.name.css', foreground: '66D9EF' },
            { token: 'attribute.value.css', foreground: 'E6DB74' },
            { token: 'keyword.css', foreground: 'F92672' },
            { token: 'delimiter.css', foreground: 'F8F8F2' },
            { token: 'number.css', foreground: 'AE81FF' },
            { token: 'string.css', foreground: 'E6DB74' },
            { token: 'unit.css', foreground: 'AE81FF' }
        ],
        colors: {
            'editor.background': '#272822',
            'editor.foreground': '#F8F8F2',
            'editor.lineHighlightBackground': '#3E3D32',
            'editorCursor.foreground': '#F8F8F0',
            'editor.selectionBackground': '#49483E'
        }
    },
    twilight: {
        base: 'vs-dark',
        inherit: true,
        rules: [
            { token: 'keyword', foreground: 'CDA869' },
            { token: 'constant.numeric', foreground: 'CF6A4C' },
            { token: 'string', foreground: '8F9D6A' },
            { token: 'comment', foreground: '5F5A60', fontStyle: 'italic' },
            { token: 'support.function', foreground: '9B703F' },
            { token: 'constant.language', foreground: 'CF6A4C' },
            // HTML
            { token: 'tag', foreground: 'CDA869' },
            { token: 'tag.id', foreground: 'CDA869' },
            { token: 'tag.class', foreground: 'CDA869' },
            { token: 'attribute.name', foreground: '9B703F' },
            { token: 'attribute.value', foreground: '8F9D6A' },
            { token: 'delimiter.html', foreground: 'F8F8F8' },
            // CSS
            { token: 'tag.css', foreground: 'CDA869' },
            { token: 'attribute.name.css', foreground: '9B703F' },
            { token: 'attribute.value.css', foreground: '8F9D6A' },
            { token: 'keyword.css', foreground: 'CDA869' },
            { token: 'delimiter.css', foreground: 'F8F8F8' },
            { token: 'number.css', foreground: 'CF6A4C' },
            { token: 'string.css', foreground: '8F9D6A' },
            { token: 'unit.css', foreground: 'CF6A4C' }
        ],
        colors: {
            'editor.background': '#141414',
            'editor.foreground': '#F8F8F8',
            'editor.lineHighlightBackground': '#1B1B1B',
            'editorCursor.foreground': '#A7A7A7',
            'editor.selectionBackground': '#323232'
        }
    },
    dreamweaver: {
        base: 'vs',
        inherit: true,
        rules: [
            { token: 'keyword', foreground: '000099', fontStyle: 'bold' },
            { token: 'constant.numeric', foreground: 'FF0000' },
            { token: 'string', foreground: 'FF0000' },
            { token: 'comment', foreground: '008200', fontStyle: 'italic' },
            { token: 'support.function', foreground: '000099' },
            { token: 'constant.language', foreground: '000099' },
            // HTML
            { token: 'tag', foreground: '000099' },
            { token: 'tag.id', foreground: '000099' },
            { token: 'tag.class', foreground: '000099' },
            { token: 'attribute.name', foreground: 'FF0000' },
            { token: 'attribute.value', foreground: '0000FF' },
            { token: 'delimiter.html', foreground: '000000' },
            // CSS
            { token: 'tag.css', foreground: '000099' },
            { token: 'attribute.name.css', foreground: 'FF0000' },
            { token: 'attribute.value.css', foreground: '0000FF' },
            { token: 'keyword.css', foreground: '000099' },
            { token: 'delimiter.css', foreground: '000000' },
            { token: 'number.css', foreground: 'FF0000' },
            { token: 'string.css', foreground: 'FF0000' },
            { token: 'unit.css', foreground: 'FF0000' }
        ],
        colors: {
            'editor.background': '#FFFFFF',
            'editor.foreground': '#000000',
            'editor.lineHighlightBackground': '#EFEFEF',
            'editorCursor.foreground': '#000000',
            'editor.selectionBackground': '#BAD6FD'
        }
    },

    eclipse: {
        base: 'vs',
        inherit: true,
        rules: [
            { token: 'keyword', foreground: '7F0055', fontStyle: 'bold' },
            { token: 'constant.numeric', foreground: '000000' },
            { token: 'string', foreground: '2A00FF' },
            { token: 'comment', foreground: '3F7F5F', fontStyle: 'italic' },
            { token: 'support.function', foreground: '7F0055' },
            { token: 'constant.language', foreground: '7F0055' },
            // HTML
            { token: 'tag', foreground: '7F0055' },
            { token: 'tag.id', foreground: '7F0055' },
            { token: 'tag.class', foreground: '7F0055' },
            { token: 'attribute.name', foreground: '7F0055' },
            { token: 'attribute.value', foreground: '2A00FF' },
            { token: 'delimiter.html', foreground: '000000' },
            // CSS
            { token: 'tag.css', foreground: '7F0055' },
            { token: 'attribute.name.css', foreground: '7F0055' },
            { token: 'attribute.value.css', foreground: '2A00FF' },
            { token: 'keyword.css', foreground: '7F0055' },
            { token: 'delimiter.css', foreground: '000000' },
            { token: 'number.css', foreground: '000000' },
            { token: 'string.css', foreground: '2A00FF' },
            { token: 'unit.css', foreground: '000000' }
        ],
        colors: {
            'editor.background': '#FFFFFF',
            'editor.foreground': '#000000',
            'editor.lineHighlightBackground': '#E8F2FF',
            'editorCursor.foreground': '#000000',
            'editor.selectionBackground': '#BAD6FD'
        }
    },

    xcode: {
        base: 'vs',
        inherit: true,
        rules: [
            { token: 'keyword', foreground: 'C800A4', fontStyle: 'bold' },
            { token: 'constant.numeric', foreground: '3A00DC' },
            { token: 'string', foreground: 'C80000' },
            { token: 'comment', foreground: '008E00', fontStyle: 'italic' },
            { token: 'support.function', foreground: '400080' },
            { token: 'constant.language', foreground: 'C800A4' },
            // HTML
            { token: 'tag', foreground: 'C800A4' },
            { token: 'tag.id', foreground: 'C800A4' },
            { token: 'tag.class', foreground: 'C800A4' },
            { token: 'attribute.name', foreground: '400080' },
            { token: 'attribute.value', foreground: 'C80000' },
            { token: 'delimiter.html', foreground: '000000' },
            // CSS
            { token: 'tag.css', foreground: 'C800A4' },
            { token: 'attribute.name.css', foreground: '400080' },
            { token: 'attribute.value.css', foreground: 'C80000' },
            { token: 'keyword.css', foreground: 'C800A4' },
            { token: 'delimiter.css', foreground: '000000' },
            { token: 'number.css', foreground: '3A00DC' },
            { token: 'string.css', foreground: 'C80000' },
            { token: 'unit.css', foreground: '3A00DC' }
        ],
        colors: {
            'editor.background': '#FFFFFF',
            'editor.foreground': '#000000',
            'editor.lineHighlightBackground': '#E8F2FF',
            'editorCursor.foreground': '#000000',
            'editor.selectionBackground': '#B5D5FF'
        }
    },

    sqlserver: {
        base: 'vs',
        inherit: true,
        rules: [
            { token: 'keyword', foreground: '0000FF', fontStyle: 'bold' },
            { token: 'constant.numeric', foreground: '000000' },
            { token: 'string', foreground: 'FF0000' },
            { token: 'comment', foreground: '008000', fontStyle: 'italic' },
            { token: 'support.function', foreground: 'FF00FF' },
            { token: 'constant.language', foreground: '0000FF' },
            // HTML
            { token: 'tag', foreground: '0000FF' },
            { token: 'tag.id', foreground: '0000FF' },
            { token: 'tag.class', foreground: '0000FF' },
            { token: 'attribute.name', foreground: 'FF00FF' },
            { token: 'attribute.value', foreground: 'FF0000' },
            { token: 'delimiter.html', foreground: '000000' },
            // CSS
            { token: 'tag.css', foreground: '0000FF' },
            { token: 'attribute.name.css', foreground: 'FF00FF' },
            { token: 'attribute.value.css', foreground: 'FF0000' },
            { token: 'keyword.css', foreground: '0000FF' },
            { token: 'delimiter.css', foreground: '000000' },
            { token: 'number.css', foreground: '000000' },
            { token: 'string.css', foreground: 'FF0000' },
            { token: 'unit.css', foreground: '000000' }
        ],
        colors: {
            'editor.background': '#FFFFFF',
            'editor.foreground': '#000000',
            'editor.lineHighlightBackground': '#E8F2FF',
            'editorCursor.foreground': '#000000',
            'editor.selectionBackground': '#ADD6FF'
        }
    },

    chaos: {
        base: 'vs-dark',
        inherit: true,
        rules: [
            { token: 'keyword', foreground: 'FF8400' },
            { token: 'constant.numeric', foreground: 'FF8400' },
            { token: 'string', foreground: 'A8FF60' },
            { token: 'comment', foreground: '888888', fontStyle: 'italic' },
            { token: 'support.function', foreground: 'FFB054' },
            { token: 'constant.language', foreground: 'FF8400' },
            // HTML
            { token: 'tag', foreground: 'FF8400' },
            { token: 'tag.id', foreground: 'FF8400' },
            { token: 'tag.class', foreground: 'FF8400' },
            { token: 'attribute.name', foreground: 'FFB054' },
            { token: 'attribute.value', foreground: 'A8FF60' },
            { token: 'delimiter.html', foreground: 'E6E1DC' },
            // CSS
            { token: 'tag.css', foreground: 'FF8400' },
            { token: 'attribute.name.css', foreground: 'FFB054' },
            { token: 'attribute.value.css', foreground: 'A8FF60' },
            { token: 'keyword.css', foreground: 'FF8400' },
            { token: 'delimiter.css', foreground: 'E6E1DC' },
            { token: 'number.css', foreground: 'FF8400' },
            { token: 'string.css', foreground: 'A8FF60' },
            { token: 'unit.css', foreground: 'FF8400' }
        ],
        colors: {
            'editor.background': '#161616',
            'editor.foreground': '#E6E1DC',
            'editor.lineHighlightBackground': '#282828',
            'editorCursor.foreground': '#FFFFFF',
            'editor.selectionBackground': '#494836'
        }
    },

    idleFingers: {
        base: 'vs-dark',
        inherit: true,
        rules: [
            { token: 'keyword', foreground: 'CC7833' },
            { token: 'constant.numeric', foreground: 'A5C261' },
            { token: 'string', foreground: 'A5C261' },
            { token: 'comment', foreground: 'BC9458', fontStyle: 'italic' },
            { token: 'support.function', foreground: 'DA4939' },
            { token: 'constant.language', foreground: '6E9CBE' },
            // HTML
            { token: 'tag', foreground: 'CC7833' },
            { token: 'tag.id', foreground: 'CC7833' },
            { token: 'tag.class', foreground: 'CC7833' },
            { token: 'attribute.name', foreground: 'DA4939' },
            { token: 'attribute.value', foreground: 'A5C261' },
            { token: 'delimiter.html', foreground: 'FFFFFF' },
            // CSS
            { token: 'tag.css', foreground: 'CC7833' },
            { token: 'attribute.name.css', foreground: 'DA4939' },
            { token: 'attribute.value.css', foreground: 'A5C261' },
            { token: 'keyword.css', foreground: 'CC7833' },
            { token: 'delimiter.css', foreground: 'FFFFFF' },
            { token: 'number.css', foreground: 'A5C261' },
            { token: 'string.css', foreground: 'A5C261' },
            { token: 'unit.css', foreground: 'A5C261' }
        ],
        colors: {
            'editor.background': '#323232',
            'editor.foreground': '#FFFFFF',
            'editor.lineHighlightBackground': '#353637',
            'editorCursor.foreground': '#91FF00',
            'editor.selectionBackground': '#5A647E'
        }
    },

    krTheme: {
        base: 'vs-dark',
        inherit: true,
        rules: [
            { token: 'keyword', foreground: '949C8B' },
            { token: 'constant.numeric', foreground: 'FFCD22' },
            { token: 'string', foreground: '8F9D6A' },
            { token: 'comment', foreground: '706D5B', fontStyle: 'italic' },
            { token: 'support.function', foreground: 'FFCD22' },
            { token: 'constant.language', foreground: 'FFCD22' },
            // HTML
            { token: 'tag', foreground: '949C8B' },
            { token: 'tag.id', foreground: '949C8B' },
            { token: 'tag.class', foreground: '949C8B' },
            { token: 'attribute.name', foreground: 'FFCD22' },
            { token: 'attribute.value', foreground: '8F9D6A' },
            { token: 'delimiter.html', foreground: 'FCFFE0' },
            // CSS
            { token: 'tag.css', foreground: '949C8B' },
            { token: 'attribute.name.css', foreground: 'FFCD22' },
            { token: 'attribute.value.css', foreground: '8F9D6A' },
            { token: 'keyword.css', foreground: '949C8B' },
            { token: 'delimiter.css', foreground: 'FCFFE0' },
            { token: 'number.css', foreground: 'FFCD22' },
            { token: 'string.css', foreground: '8F9D6A' },
            { token: 'unit.css', foreground: 'FFCD22' }
        ],
        colors: {
            'editor.background': '#0B0A09',
            'editor.foreground': '#FCFFE0',
            'editor.lineHighlightBackground': '#1C1B1A',
            'editorCursor.foreground': '#FF9900',
            'editor.selectionBackground': '#444444'
        }
    },
};